(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ns-inquiry"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-ns-inquiry]').forEach(function (wrap) {
    var form = wrap.querySelector('form');
    if (!form) return;
    var cards = [].slice.call(wrap.querySelectorAll('[data-inq-card]'));
    var bars = [].slice.call(wrap.querySelectorAll('.inq-progress i'));
    var label = wrap.querySelector('[data-inq-label]');
    var back = wrap.querySelector('[data-inq-back]');
    var next = wrap.querySelector('[data-inq-next]');
    var summary = wrap.querySelector('[data-inq-summary]');
    var img = wrap.querySelector('[data-inq-img]');
    if (cards.length < 2) return;

    wrap.classList.add('js-on');
    /* Shuffle the card imagery so the page is not identical on every visit (Fahad 2026-08-18). */
    if (img) {
      var pool = [];
      for (var k = 1; k <= 5; k++) { var v = img.getAttribute('data-src-' + k); if (v) pool.push(v); }
      for (var z = pool.length - 1; z > 0; z--) { var j = Math.floor(Math.random() * (z + 1)); var t = pool[z]; pool[z] = pool[j]; pool[j] = t; }
      pool.forEach(function (src, n) { img.setAttribute('data-src-' + (n + 1), src); });
      img.setAttribute('src', pool[0]);
      requestAnimationFrame(function () { img.classList.add('is-settled'); });
    }
    var i = 0;

    function labelFor(el) {
      var l = wrap.querySelector('label[for="' + el.id + '"]');
      return l ? l.textContent.replace(/\(optional\)/i, '').trim() : el.name;
    }
    function clearErr(el) {
      el.classList.remove('is-bad');
      var n = el.parentNode.querySelector('.inq-err');
      if (n) n.remove();
    }
    function fail(el, msg) {
      el.classList.add('is-bad');
      if (!el.parentNode.querySelector('.inq-err')) {
        var p = document.createElement('p');
        p.className = 'inq-err'; p.textContent = msg;
        el.parentNode.appendChild(p);
      }
    }
    function validate(card) {
      var ok = true, first = null;
      [].slice.call(card.querySelectorAll('[data-inq-req]')).forEach(function (el) {
        clearErr(el);
        var v = (el.value || '').trim();
        if (!v) { fail(el, 'This one is needed.'); ok = false; first = first || el; return; }
        if (el.type === 'email' && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) {
          fail(el, 'Check the email address.'); ok = false; first = first || el;
        }
      });
      if (first) first.focus();
      return ok;
    }
    function buildSummary() {
      if (!summary) return;
      summary.innerHTML = '';
      cards.forEach(function (c) {
        if (c.hasAttribute('data-inq-review')) return;
        [].slice.call(c.querySelectorAll('input, select, textarea')).forEach(function (el) {
          if (!el.name || el.name.indexOf('contact[') !== 0) return;
          var v = (el.value || '').trim();
          if (!v) return;
          var dt = document.createElement('dt'); dt.textContent = labelFor(el);
          var dd = document.createElement('dd'); dd.textContent = v;
          summary.appendChild(dt); summary.appendChild(dd);
        });
      });
    }
    function swapImage(n) {
      if (!img) return;
      var src = img.getAttribute('data-src-' + (n + 1));
      if (!src || img.getAttribute('src') === src) return;
      img.style.opacity = '0';
      setTimeout(function () {
        img.setAttribute('src', src);
        img.style.opacity = '1';
      }, 200);
    }
    function show(n) {
      i = n;
      cards.forEach(function (c, x) { c.classList.toggle('is-on', x === n); });
      bars.forEach(function (b, x) {
        b.classList.toggle('is-done', x < n);
        b.classList.toggle('is-now', x === n);
      });
      if (label) label.textContent = 'Step ' + (n + 1) + ' of ' + cards.length;
      wrap.classList.toggle('on-review', n === cards.length - 1);
      if (back) back.hidden = (n === 0);
      if (n === cards.length - 1) buildSummary();
      swapImage(n);
      var top = wrap.getBoundingClientRect().top + window.pageYOffset - 90;
      if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
      var h = cards[n].querySelector('.inq-legend');
      if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
    }
    var reply = wrap.querySelector('[data-inq-reply]');
    var phone = wrap.querySelector('[data-inq-phone]');
    var phoneOpt = wrap.querySelector('[data-inq-phone-opt]');
    if (reply && phone) {
      reply.addEventListener('change', function () {
        var needs = /whatsapp/i.test(reply.value);
        if (needs) { phone.setAttribute('data-inq-req', ''); if (phoneOpt) phoneOpt.textContent = ''; }
        else { phone.removeAttribute('data-inq-req'); if (phoneOpt) phoneOpt.textContent = '(optional)'; }
      });
    }
    if (next) next.addEventListener('click', function () {
      if (!validate(cards[i])) return;
      if (i < cards.length - 1) show(i + 1);
    });
    if (back) back.addEventListener('click', function () { if (i > 0) show(i - 1); });
    form.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA' && !wrap.classList.contains('on-review')) {
        e.preventDefault(); if (next) next.click();
      }
    });
    show(0);

    form.addEventListener('submit', function (e) {
      var bad = null;
      cards.forEach(function (c) {
        if (c.hasAttribute('data-inq-review')) return;
        [].slice.call(c.querySelectorAll('[data-inq-req]')).forEach(function (el) {
          if (!(el.value || '').trim() && !bad) bad = c;
        });
      });
      if (bad) { e.preventDefault(); show(cards.indexOf(bad)); validate(bad); return; }
      try {
        var hp = form.querySelector('[name="ns_hp_url"]');
        if (hp && hp.value) return;
        var key = wrap.getAttribute('data-kl-key');
        if (!key) return;
        var props = {};
        form.querySelectorAll('[name^="contact["]').forEach(function (el) {
          var m = el.name.match(/^contact\[(.+)\]$/);
          if (m && el.value) props[m[1]] = el.value;
        });
        props.source_page = window.location.pathname;
        if (!props.email) return;
        fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(key), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify({ data: { type: 'event', attributes: {
            properties: props,
            metric: { data: { type: 'metric', attributes: { name: wrap.getAttribute('data-kl-metric') || 'Inquiry' } } },
            profile: { data: { type: 'profile', attributes: { email: props.email, first_name: props.name || '' } } }
          } } }),
          keepalive: true
        }).catch(function () {});
      } catch (err) {}
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
